// extracted by mini-css-extract-plugin
module.exports = {"logoutButton":"LogoutButton-module__logoutButton___2qVT0"};